export default "__VITE_ASSET__D3dHj422__"